import React from "react";
import { motion } from "framer-motion";
import { customiseNeeds } from "../Data";

const CustomProjectNeeds = () => {
    return(
        <>
          <section className="customise-needs-section">

  <div className="container">

    {/* SUBHEADING */}
    <motion.h3
      className="section-subheading"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
    >
      FULFILLING YOUR PROJECT NEEDS
    </motion.h3>

    {/* HEADING */}
    <motion.h2
      className="section-heading"
      initial={{ opacity: 0, y: 35 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{
        delay: 0.15,
        duration: 0.75,
        ease: [0.22, 1, 0.36, 1],
      }}
      viewport={{ once: true }}
    >
      What can we Customise ?
    </motion.h2>

    {/* GRID */}
    <motion.div
      className="customise-needs-grid"
      variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.14,
          },
        },
      }}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.12 }}
    >

      {customiseNeeds.map((item, i) => (

        <motion.div
          className="customise-needs-item"
          key={i}
          variants={{
            hidden: {
              opacity: 0,
              y: 60,
            },
            visible: {
              opacity: 1,
              y: 0,
            },
          }}
          transition={{
            duration: 0.75,
            ease: [0.22, 1, 0.36, 1],
          }}
        >

          {/* CARD */}
          <motion.div
            className="customise-needs-card"
            whileHover={{
              y: -10,
            }}
            transition={{
              duration: 0.3,
            }}
          >

            {/* ICON */}
            <motion.div
              className="customise-needs-icon"
              initial={{
                scale: 0,
                rotate: -10,
              }}
              whileInView={{
                scale: 1,
                rotate: 0,
              }}
              transition={{
                delay: 0.2 + i * 0.08,
                type: "spring",
                stiffness: 180,
                damping: 12,
              }}
              viewport={{ once: true }}
              whileHover={{
                scale: 1.08,
                rotate: 4,
              }}
            >

              <motion.img
                src={item.icon}
                alt={`${item.title} | Gurukrupa Wood Pvt. Ltd.`}
                whileHover={{
                  scale: 1.08,
                }}
                transition={{
                  duration: 0.3,
                }}
              />

            </motion.div>

            {/* TITLE */}
            <motion.h4
              className="card-heading"
              initial={{
                opacity: 0,
                y: 18,
              }}
              whileInView={{
                opacity: 1,
                y: 0,
              }}
              transition={{
                delay: 0.3 + i * 0.08,
                duration: 0.5,
              }}
              viewport={{ once: true }}
            >
              {item.title}
            </motion.h4>

          </motion.div>

          {/* ARROW */}
          {i !== customiseNeeds.length - 1 && (

            <motion.div
              className="customise-needs-arrow"
              initial={{
                opacity: 0,
                x: -15,
              }}
              whileInView={{
                opacity: 1,
                x: 0,
              }}
              transition={{
                delay: 0.45 + i * 0.08,
                duration: 0.45,
              }}
              viewport={{ once: true }}
              animate={{
                x: [0, 6, 0],
              }}
              style={{
                animationDuration: "2s",
              }}
            >
              ›
            </motion.div>

          )}

        </motion.div>

      ))}

    </motion.div>

  </div>

</section>

        </>
    )
}
export default CustomProjectNeeds;